import WarpElement from "@warp-ds/elements-core";
import "@warp-ds/elements/components/badge";
import { clickable } from "@warp-ds/css/component-classes";
import { css, html } from "lit";
import { i18n } from "@lingui/core";
import { trackClickEvent } from "../tracking.js";
import { eventReference, TrackingEventMap } from "../../models/trackingEvent.js";
import { activateI18n } from "../../utils/i18n.js";
import { Brand } from "../../constants.js";

class CarguideBanner extends WarpElement {
    declare imageUrl: string;
    declare trackingEventMap: TrackingEventMap;
    declare brand: Brand;

    static properties = {
        imageUrl: { type: String },
        trackingEventMap: { type: Object },
        brand: { attribute: true, type: Brand },
    };

    static styles = [
        WarpElement.styles,
        css`
            @css-placeholder-6zvZfv;
        `,
    ];

    constructor() {
        super();
    }

    connectedCallback() {
        activateI18n();
        super.connectedCallback();
    }

    getLink = () => {
        switch (this.brand) {
            case Brand.DBA:
                return "https://blog.bilbasen.dk/";
            case Brand.BLOCKET:
                return "https://www.blocket.se/tips-och-guider/bilguiden";
            default:
                return "https://blog.bilbasen.dk/";
        }
    };

    render() {
        const link = this.getLink();
        if (!link) {
            return html``;
        }
        return html`<w-card>
            <div class="flex md:flex-row flex-col-reverse relative min-h-[160]">
                <w-badge position="top-right" class="z-10">
                    ${i18n.t({
                        id: "market-frontpage.car-guide-banner.badge",
                        message: "Guide",
                    })}
                </w-badge>
                <div class="md:m-24 m-16 flex-1 flex flex-col justify-between md:min-w-[300]">
                    <div class="flex-1">
                        <h2 class="text-body font-bold">
                            ${i18n.t({
                                id: "market-frontpage.car-guide-banner.title",
                                message: "Get inspiration for your next car purchase",
                            })}
                        </h2>
                        <p class="text-caption s-text-subtle mb-16">
                            ${i18n.t({
                                id: "market-frontpage.car-guide-banner.description",
                                message: "In this car guide, you can learn more about used cars.",
                            })}
                        </p>
                    </div>
                    <h3 class="mb-0">
                        <a
                            class="text-caption font-bold"
                            href="${link}"
                            @click="${() => trackClickEvent(this.trackingEventMap[eventReference.DBA_CAR_GUIDE], link)}"
                        >
                            <span class="${clickable.buttonOrLinkStretch}" aria-hidden="true"></span>
                            ${i18n.t({
                                id: "market-frontpage.car-guide-banner.linktext",
                                message: "Read more",
                            })}</a
                        >
                    </h3>
                </div>
                <img class="object-cover flex-1 max-h-[160] md:max-w-[464] md:max-h-full" src="${this.imageUrl}" />
            </div>
        </w-card>`;
    }
}

customElements.define("mfp-carguide-banner", CarguideBanner as unknown as CustomElementConstructor);
